import { listCard } from "./fields.css";

import { useAtomValue } from "jotai";

import { Fieldset, FieldsetLegend } from "@frontend/components/atoms/Fieldset";
import { Input } from "@frontend/components/atoms/Input";
import { useArrayField, useField } from "@frontend/hooks/form";
import { getPhoneMask } from "@frontend/utils/masks";
import { Trans } from "@lingui/react/macro";

import { useContactForm } from "../../hooks/useContactForm";
import { ContactPhonePlaceLabels } from "../../i18n";
import { isEditModeAtom } from "../../stores";
import type { ContactPhone, PhoneListItemNumberField } from "../../types";
import { AddButton } from "./AddButton";
import { ClipboardButton } from "./ClipboardButton";
import { FieldList } from "./FieldList";
import { Place } from "./Place";

export function PhoneList() {
  const { contactForm } = useContactForm();

  const field = contactForm.fields.phones;

  const rows = useArrayField(field);

  const editMode = useAtomValue(isEditModeAtom);

  const removeHandler = (index: number) => {
    rows.remove(rows.itemAtoms[index]!);
  };

  const insertHandler = () => {
    rows.append({ place: "", number: "" } as ContactPhone);
  };

  return (
    <Fieldset variant="list" orientation="horizontal" className={listCard}>
      <FieldsetLegend
        count={rows.items.length}
        action={editMode && <AddButton onClick={insertHandler} />}
      >
        <Trans>Phones</Trans>
      </FieldsetLegend>

      <FieldList
        field={field}
        onRemove={removeHandler}
        renderLeft={(item) => (
          <Place field={item.fields.place} labels={ContactPhonePlaceLabels} />
        )}
        renderRight={(item) => (
          <PhoneListItemNumber field={item.fields.number} />
        )}
      />
    </Fieldset>
  );
}

function PhoneListItemNumber({ field }: { field: PhoneListItemNumberField }) {
  const editMode = useAtomValue(isEditModeAtom);

  const { value: number, setValue: setNumber, error } = useField(field);

  return editMode ? (
    <Input
      value={number}
      onValueChange={setNumber}
      invalid={null !== error}
      mask={getPhoneMask()}
      size="sm"
    />
  ) : (
    <>
      <span>{number}</span>
      <ClipboardButton value={number ?? ""} />
    </>
  );
}
